import React from 'react';
import {
    Box,
    Button,
    Container,
    FormHelperText,
    Grid,
    TextField,
    Typography,
    Snackbar,
    Alert,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    IconButton
} from "@mui/material";

import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const LoginComp = (props) => {
    const [showPassword, setShowPassword] = React.useState(false);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4} alignItems="center">

                    {/* Left Section */}
                    <Grid item xs={12} md={7}>
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            color="#fff"
                            gutterBottom
                        >
                            Pin Click GPT
                        </Typography>
                        {/* <Typography color="#cbd5e1" fontSize={18}>
                            Smart AI powered CRM to manage leads, projects and conversions seamlessly.
                        </Typography> */}
                    </Grid>

                    {/* Login Card */}
                    <Grid item xs={12} md={5}>
                        <Box
                            sx={{
                                backdropFilter: 'blur(14px)',
                                background: 'rgba(255,255,255,0.08)',
                                borderRadius: 3,
                                p: 4,
                                boxShadow: '0 20px 40px rgba(0,0,0,0.4)'
                            }}
                        >
                            <Typography
                                variant="h5"
                                fontWeight="bold"
                                color="#fff"
                                mb={1}
                            >
                                Welcome Back 👋
                            </Typography>

                            <Typography color="#94a3b8" mb={3}>
                                Sign in to continue
                            </Typography>

                            {/* Username */}
                            <TextField
                                fullWidth
                                label="User Name"
                                variant="outlined"
                                margin="normal"
                                onKeyDown={(e) => { if (e.key === "Enter") props.SignIn(); }}
                                onChange={(e) => props.HandleInputs(e, 'txtLoginUserName')}
                                value={props.state.txtLoginUserName}
                                error={props.state.txtLoginUserNameErr !== ''}
                                helperText={props.state.txtLoginUserNameErr}
                                sx={{
                                    input: { color: '#fff' },
                                    label: { color: '#94a3b8' },
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#475569' },
                                        '&:hover fieldset': { borderColor: '#6366f1' },
                                        '&.Mui-focused fieldset': { borderColor: '#6366f1' }
                                    }
                                }}
                            />

                            {/* Password */}
                            <FormControl fullWidth margin="normal" variant="outlined">
                                <InputLabel
                                    htmlFor="login-password"
                                    sx={{ color: '#94a3b8' }}
                                >
                                    Password
                                </InputLabel>

                                <OutlinedInput
                                    id="login-password"
                                    label="Password"   // 🔴 THIS IS REQUIRED
                                    type={showPassword ? 'text' : 'password'}
                                    value={props.state.txtLoginPassword}
                                    error={props.state.txtLoginPasswordErr !== ''}
                                    onChange={(e) => props.HandleInputs(e, 'txtLoginPassword')}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") props.SignIn();
                                    }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setShowPassword(!showPassword)}
                                                edge="end"
                                                sx={{ color: '#cbd5e1' }}
                                            >
                                                {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    sx={{
                                        color: '#fff',
                                        '& fieldset': { borderColor: '#475569' },
                                        '&:hover fieldset': { borderColor: '#6366f1' },
                                        '&.Mui-focused fieldset': { borderColor: '#6366f1' }
                                    }}
                                />

                                <FormHelperText error>
                                    {props.state.txtLoginPasswordErr}
                                </FormHelperText>
                            </FormControl>


                            {/* Button */}
                            <Box mt={3}>
                                {props.login === false ? (
                                    <Button
                                        fullWidth
                                        size="large"
                                        variant="contained"
                                        onClick={() => props.SignIn()}
                                        sx={{
                                            background: 'linear-gradient(90deg, #6366f1, #4f46e5)',
                                            fontWeight: 'bold',
                                            py: 1.4,
                                            borderRadius: 2,
                                            '&:hover': {
                                                background: 'linear-gradient(90deg, #4f46e5, #4338ca)'
                                            }
                                        }}
                                    >
                                        Sign In
                                    </Button>
                                ) : (
                                    <LoadingButton
                                        loading
                                        loadingPosition="start"
                                        startIcon={<SaveIcon />}
                                        fullWidth
                                        size="large"
                                        variant="outlined"
                                        sx={{
                                            color: '#fff',
                                            borderColor: '#6366f1'
                                        }}
                                    >
                                        Sign In
                                    </LoadingButton>
                                )}
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Container>

            {/* Snackbar */}
            <Snackbar
                open={props.state.showAlert}
                autoHideDuration={3000}
                onClose={() => props.handleCloseAlert()}
            >
                <Alert
                    onClose={() => props.handleCloseAlert()}
                    severity={props.state.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {props.state.alertMsg}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default LoginComp;
